import React from 'react';
import { Loader2 } from 'lucide-react';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  'aria-label'?: string;
}

const SIZE_MAP: Record<SpinnerSize, number> = {
  sm: 16,
  md: 24,
  lg: 32,
};

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className = '',
  'aria-label': ariaLabel = 'Loading',
}) => {
  return (
    <Loader2
      size={SIZE_MAP[size]}
      className={`animate-spin text-pt-forest ${className}`}
      role="status"
      aria-label={ariaLabel}
    />
  );
};

export default Spinner;
